import { Alert, Button, Card, Icon, notification } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getUrlParams } from '../../../routes'
import {
  getSingleAbstractAction,
  abstractNoteCountFxn,
  listAbstractNotesFxn,
  deleteAbstractNoteFxn
} from './actions'
import DeleteAbstractDrawer from './DeleteAbstractDrawer'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import AbstractStatus from './AbstractStatus'
import AbstractReducer from '../../../containers/onlineAbstract/reducer/AbstractReducer'
import AbstractDetails from './AbstractDetails'
import UpdateStatusDrawer from './UpdateStatusDrawer'
import { ReviewerDetails } from './reviewer/ReviewerDetails'
import { RowTable, CustomCardTitle } from '../../article/articleView/RowTable'
import WithdrawalAbstractDrawer from './WithdrawalAbstractDrawer'
import AbstractActivityList from './AbstractActivityList'
import DOIDetails from './abstractPages/AbstractDOIDetails'
import AbstractNotesDrawer from './abstractViewNotesDrawer'
import AbstractFAQDrawer from './AbstractFAQDrawer'
import AbstractGraphicalRepresentationDrawer from './AbstractGraphicalRepresentationDrawer'
import ProcessingCharges from './abstractPages/AbstractProcessingCharges';
import ReviewedAbstracts from './abstractPages/ReviewedAbstracts';
import CommentsToAuthor from './abstractPages/CommentsToAuthor';
import CommentsToAbstractDrawer from './abstractPages/AbstractCommentsDrawer'
import RevisedAbstractPage from './abstractPages/RevisedAbstractPage'
import ApprovedAbstractDetails from './abstractPages/ApprovedAbstractDetails'
import AcceptedAbstractDetails from './abstractPages/AcceptedAbstractDetails'
import OnlineAbstractDetails from './abstractPages/OnlineAbstractDetails'
import {
  AcceptanceArticleDetails,
  OnlineArticleDetails,
  ReviewedArticles
} from '../../article/articleView/articlePages'

const $ = window.$

class AbstractView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      abstract: {},
      visibleDrawer: false,
      visibleWithdrawalDrawer: false,
      visibleAddNote: false,
      visibleFAQDrawer: false,
      visibleGraphicalDrawer: false,
      visibleActivityList: false,
      visibleCommentsDrawer: false,
      noteArrived: false,
      totalNotes: 0,
      visibleUpdateStatus: false
    }
  }
  reducerStop = () => {
    this.props.dispatch({ type: 'STOP_LOAD_ABSTRACT' });
    this.props.dispatch({ type: 'REFRESH_ABSTRACT', refreshAbstract: false });
  }
  componentDidMount() {
    this._isMounted = true;
    this.reducerStop();
    this.loadSingleAbstract()
    this.stickyHeader()
    this.loadAbstractCount()
  }
  componentDidUpdate(prevProps) {
    // We check prevProps vs current props to guarantee it only fires ONCE
    if (
      this.props.AbstractReducer &&
      this.props.AbstractReducer.loadAbstract &&
      (!prevProps.AbstractReducer || !prevProps.AbstractReducer.loadAbstract)
    ) {
      console.log("Triggering safe Redux reload...");
      this.loadSingleAbstract();
      this.props.dispatch({ type: 'STOP_LOAD_ABSTRACT' });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  // loadSingleAbstract = async () => {
  //   let urlObj = getUrlParams('onlineAbstractsGroup.viewAbstract', window.location.pathname)
  //   if (urlObj && urlObj.id) {
  //     let resp = await this.props.dispatch(getSingleAbstractAction(urlObj.id))
  //     if (resp && resp.data) {
  //       this.setState({ abstract: resp.data })
  //       // document.title = `Abstract - ${resp.data.abstractId || 'View'}`
  //       document.title = `Abstract - ${resp.data.abstractNo}`
  //       this.checkAbstractNotes(resp.data._id)
  //     } else {
  //       notification.error({ message: 'Error Loading Abstract Data' })
  //     }
  //   }
  // }
  loadSingleAbstract = async () => {
    let urlObj = getUrlParams('onlineAbstractsGroup.viewAbstract', window.location.pathname)
    if (urlObj && urlObj.id) {
      let resp = await this.props.dispatch(getSingleAbstractAction(urlObj.id))

      // Safety check: Only update state if the component is still alive
      if (this._isMounted && resp && resp.data) {
        this.setState({ abstract: resp.data })
        document.title = `Abstract - ${resp.data.abstractNo}`
        this.checkAbstractNotes(resp.data._id)
      } else if (!resp.data) {
        notification.error({ message: 'Error Loading Abstract Data' })
      }
    }
  }
  checkAbstractNotes = async (_id) => {
    let data = await listAbstractNotesFxn({ abstractId: _id })
    if (data && !data.error) {
      this.setState({ noteArrived: true })
    }
  }

  // loadAbstractCount = async () => {
  //   let urlObj = getUrlParams('onlineAbstractsGroup.viewAbstract', window.location.pathname)
  //   if (urlObj && urlObj.id) {
  //     let { data } = await abstractNoteCountFxn({ abstractId: urlObj.id })
  //     this.setState({ totalNotes: data })
  //   }
  // }
  loadAbstractCount = async () => {
    let urlObj = getUrlParams('onlineAbstractsGroup.viewAbstract', window.location.pathname)
    console.log("DEBUG: Sending ID to API:", urlObj.id); // Check this log!

    if (urlObj && urlObj.id) {
      // Ensure this function actually passes the ID correctly
      let resp = await abstractNoteCountFxn({ abstractId: urlObj.id });
      console.log("DEBUG: Load Count Response:", resp);
      this.setState({ totalNotes: resp.data || 0 });
    }
  }
  stickyHeader = () => {
    $(window).scroll(function () {
      let classCheck = $('aside').hasClass('ant-layout-sider-collapsed') ? 'fixedColl' : 'fixed'
      if ($(window).scrollTop() >= 250) {
        $('.sticky-header').addClass(classCheck)
        $('.headerPanel').addClass('sticky-header-bg')
      } else {
        $('.sticky-header').removeClass('fixedColl fixed')
        $('.headerPanel').removeClass('sticky-header-bg')
      }
    })
  }

  deleteAbstractNotes = async (_id) => {
    let data = await deleteAbstractNoteFxn({ abstractId: _id })
    if (!data.error) {
      this.setState({ visibleAddNote: true, noteArrived: false })
    }
  }

  render() {
    let { abstract, totalNotes, noteArrived } = this.state
    let { currentUser } = this.props


    return (
      <PageHeaderWrapper
        title={
          <div className={'sticky-header'}>
            <div className={'headerPanel abstract'}>
              <div className={'titleDiv'}>
                {/*Abstract Details | ID - {abstract.onlineAbstractId}*/}
                <div className={'titleDiv'}>
                  Abstract Details | Abstract No. - {abstract.abstractNo}
                </div>
              </div>
              <div className={'btn-group'}>
                <Button
                  key='1'
                  type='danger'
                  className={'marginH'}
                  onClick={() => this.setState({ visibleDrawer: true })}>
                  <Icon type={'delete'} />
                  Delete
                </Button>
                <Button
                  key='2'
                  type='warning'
                  className={'marginH'}
                  onClick={() => this.setState({ visibleWithdrawalDrawer: true })}>
                  <Icon type={'rollback'} /> Withdrawal
                </Button>
                {/*<Button*/}
                {/*  className={'marginH ant-btn-success-new'}*/}
                {/*  onClick={() => this.setState({ visibleAddNote: true })}>*/}
                {/*  <Icon type={'plus'} /> Notes ({totalNotes})*/}
                {/*</Button>*/}
                <Button
                  className={'marginH ant-btn-success-new'}
                  onClick={() => {
                    console.log("Current visibleAddNote state:", this.state.visibleAddNote);
                    this.setState({ visibleAddNote: true }, () => {
                      console.log('State updated to true. Drawer should now be visible.')
                    });
                  }}>
                  <Icon type={'plus'} /> Notes ({totalNotes})
                </Button>
                <Button
                  type={'primary'}
                  style={{ backgroundColor: '#a711a7ff', borderColor: '#a711a7ff', color: 'white' }}
                  className={'marginH'}
                  onClick={() => this.setState({ visibleFAQDrawer: true })}>
                  <Icon type={'question-circle'} /> Add faq
                </Button>
                <Button
                  type={'primary'}
                  className={'marginH ant-btn-success-new'}
                  onClick={() => this.setState({ visibleGraphicalDrawer: true })}>
                  <Icon type={'picture'} /> Graphical Representation
                </Button>
                <Button type={'info'} className={'marginH'} onClick={() => this.setState({ visibleActivityList: true })}>
                  <Icon type={'eye'} /> Absrtact Activities
                </Button>
                {currentUser.userType === 'Admin' && (
                  <Button
                    key='5'
                    type={'dark'}
                    className={'marginH'}
                    onClick={() => this.setState({ visibleUpdateStatus: true })}>
                    <Icon type={'edit'} />
                    Update Status
                  </Button>
                )}
              </div>
            </div>
          </div>
        }>
        <Card>
          <AbstractStatus abstract={abstract} />
          <AbstractDetails abstract={abstract} />
          {/*<ProcessingCharges*/}
          {/*  abstract={abstract}*/}
          {/*  callback={this.loadSingleAbstract}*/}
          {/*/>*/}
          {/* Final optimized block for AbstractView.js */}
          {/*{abstract.selectedReviewer && abstract.selectedReviewer.length > 0 && (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      /!*<CustomCardTitle title={'Under Review'} />*!/*/}
          {/*      <div className={'tableBox striped'}>*/}
          {/*        <ReviewerDetails abstract={abstract} />*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*)}*/}
          {/*{(abstract.status === 'Submitted Abstract' ||*/}
          {/*  abstract.status === 'Abstract Under Review' ||*/}
          {/*  abstract.status === 'Reviewed Comments' ||*/}
          {/*  abstract.status === 'Revised Abstract' ||*/}
          {/*  abstract.status === 'Approved Abstract' ||*/}
          {/*  abstract.status === 'Accepted Abstract' ||*/}
          {/*  abstract.status === 'Comments To Author') ? (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      <div className={'tableBox striped'}>*/}
          {/*        <ReviewerDetails abstract={abstract}*/}
          {/*          onRefresh={this.loadSingleAbstract} />*/}

          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {/*{abstract.createdAt ? (<ReviewerDetails abstract={this.state.abstract} />) : null}*/}
          {abstract.createdAt ? (
            <ReviewerDetails
              abstract={this.state.abstract}
              onRefresh={this.loadSingleAbstract}
            />
          ) : null}
          {/*{abstract.underReviewDetails &&*/}
          {/*abstract.underReviewDetails.receiveDate ? (*/}
          {/*  <ReviewedArticles abstract={abstract} />*/}
          {/*) : null}*/}
          {abstract.selectedReviewer && abstract.selectedReviewer.some(r => r.receiveDate) ? (
            <ReviewedAbstracts
              abstract={abstract}
              onRefresh={this.loadSingleAbstract}
            />
          ) : null}
          {/*{abstract.selectedReviewer && abstract.selectedReviewer.some(r => r.receiveDate) && (*/}
          {/*  <ReviewedAbstracts abstract={abstract} />*/}
          {/*)}*/}
          {/*{abstract.status === 'Reviewed Comments' &&*/}
          {/*abstract.selectedReviewer &&*/}
          {/*abstract.selectedReviewer.some(r => r.receiveDate) ? (*/}
          {/*  <ReviewedAbstracts abstract={abstract} />*/}
          {/*) : null}*/}
          {/*{abstract.status === 'Reviewed Comments' &&*/}
          {/*abstract.selectedReviewer &&*/}
          {/*abstract.selectedReviewer.some(r => r.receiveDate) ? (*/}
          {/*  <ReviewedAbstracts*/}
          {/*    abstract={abstract}*/}
          {/*    onRefresh={this.loadSingleAbstract}*/}
          {/*  />*/}
          {/*) : null}*/}
          {/*{(abstract.sendToAuthorDate || abstract.rejectionDate) && (*/}
          {/*  <CommentsToAuthor abstract={abstract} />*/}
          {/*)}*/}
          {/*{(abstract.status === 'Reviewed Comments' ||*/}
          {/*  abstract.status === 'Comments To Author' ||*/}
          {/*  abstract.status === 'Revised Abstract') ? (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      <div className={'tableBox striped'}>*/}
          {/*        /!*<CommentsToAuthor abstract={abstract} />*!/*/}
          {/*        <CommentsToAuthor*/}
          {/*          abstract={abstract}*/}
          {/*          callback={this.loadSingleAbstract}*/}
          {/*          showCommentsDrawer={() => this.setState({ visibleCommentsDrawer: true })}*/}
          {/*        />*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {abstract.selectedReviewer && abstract.selectedReviewer.some(r => r.receiveDate) ? (
            <div style={{ marginTop: '20px' }}>
              <div className={'customBox'}>
                <div className={'tableBox striped'}>
                  <CommentsToAuthor
                    abstract={abstract}
                    callback={this.loadSingleAbstract}
                    showCommentsDrawer={() => this.setState({ visibleCommentsDrawer: true })}
                  />
                </div>
              </div>
            </div>
          ) : null}
          {/*{abstract.sendToAuthorDate ? (*/}
          {/*  <RevisedAbstractPage abstract={abstract} />*/}
          {/*) : null}*/}
          {/*{(abstract.status === 'Revised Abstract' || abstract.sendToAuthorDate) ? (*/}
          {/*  <RevisedAbstractPage*/}
          {/*    abstract={abstract}*/}
          {/*    callback={() => this.loadSingleAbstract()}*/}
          {/*  />*/}
          {/*) : null}*/}
          {/*{(abstract.status === 'Revised Abstract' || abstract.sendToAuthorDate) ? (*/}
          {/*  <RevisedAbstractPage*/}
          {/*    abstract={abstract}*/}
          {/*    // Stagger the parent refresh to allow child animations to finish*/}
          {/*    callback={() => setTimeout(() => this.loadSingleAbstract(), 300)}*/}
          {/*  />*/}
          {/*) : null}*/}
          {/*{abstract.sendToAuthorDate ? (*/}
          {/*  <RevisedAbstractPage*/}
          {/*    abstract={abstract}*/}
          {/*    callback={() => setTimeout(() => this.loadSingleAbstract(), 300)}*/}
          {/*  />*/}
          {/*) : null}*/}
          {abstract.sendToAuthorDate ? (
            <RevisedAbstractPage abstract={abstract} />
          ) : null}
          {/*{(abstract.status === 'Revised Abstract' || abstract.approvedAbstractDate) ? (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      <ApprovedAbstractDetails*/}
          {/*        abstract={abstract}*/}
          {/*        onRefresh={this.loadSingleAbstract}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {abstract.revisedAbstractDate ? (
            <div style={{ marginTop: '20px' }}>
              <div className={'customBox'}>
                <ApprovedAbstractDetails
                  abstract={abstract}
                  onRefresh={this.loadSingleAbstract}
                />
              </div>
            </div>
          ) : null}
          {/*{(abstract.status === 'Accepted Abstract' || abstract.status === 'Approved Abstract' || abstract.status === 'Online Publish') ? (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      <AcceptedAbstractDetails*/}
          {/*        abstract={abstract}*/}
          {/*        onRefresh={this.loadSingleAbstract}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {abstract.approvedAbstractDate ? (
            <AcceptedAbstractDetails abstract={abstract} />
          ) : null}

          {/*{(abstract.status === 'Accepted Abstract' || abstract.status === 'DOI' || abstract.status === 'Published' || abstract.doiProcessDate) ? (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      <DOIDetails abstract={abstract} />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {abstract.approvedAbstractPaymentDate ? (
            <DOIDetails abstract={abstract} />
          ) : null}

          {/*{abstract.doiProcessDate || abstract.onlinePublishedDate ? (*/}
          {/*  <div style={{ marginTop: '20px' }}>*/}
          {/*    <div className={'customBox'}>*/}
          {/*      <OnlineAbstractDetails abstract={abstract} />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {abstract.doiProcessDate ? (
            <OnlineAbstractDetails abstract={abstract} />
          ) : null}

          {abstract.approvedDate ? <p>Approved on: {abstract.approvedDate}</p> : null}
        </Card>
        {abstract.status === "Abstract Under Process" ? (
          <div style={{ marginBottom: '20px' }}>
            <Alert
              message="Current Status: Abstract Under Process"
              description="The abstract has been received and is currently being processed by the editorial team."
              type="info"
              showIcon
            />
          </div>
        ) : null}
        {this.state.visibleAddNote && (
          <AbstractNotesDrawer
            visible={this.state.visibleAddNote}
            abstractId={abstract._id}
            onClose={() => {
              this.setState({ visibleAddNote: false });
              this.loadAbstractCount();
            }}
          />
        )}
        {this.state.visibleFAQDrawer && (
          <AbstractFAQDrawer
            visible={this.state.visibleFAQDrawer}
            abstract={abstract}
            onClose={() => this.setState({ visibleFAQDrawer: false })}
            onRefresh={this.loadSingleAbstract}
          />
        )}
        {this.state.visibleGraphicalDrawer && (
          <AbstractGraphicalRepresentationDrawer
            visible={this.state.visibleGraphicalDrawer}
            abstract={abstract}
            onClose={() => this.setState({ visibleGraphicalDrawer: false })}
            onRefresh={this.loadSingleAbstract}
          />
        )}
        {this.state.visibleDrawer && (
          <DeleteAbstractDrawer
            visible={this.state.visibleDrawer}
            abstract={abstract}
            onClose={() => this.setState({ visibleDrawer: false })}
          />
        )}

        {/*{this.state.visibleUpdateStatus && (*/}
        {/*  <UpdateStatusDrawer*/}
        {/*    visible={this.state.visibleUpdateStatus}*/}
        {/*    abstract={abstract}*/}
        {/*    onClose={() => this.setState({ visibleUpdateStatus: false })}*/}
        {/*    onSubmit={(updatedAbstract) => {*/}
        {/*      this.setState({ visibleUpdateStatus: false, abstract: updatedAbstract })*/}
        {/*    }}*/}
        {/*{this.state.visibleUpdateStatus && (*/}
        {/*  <UpdateStatusDrawer*/}
        {/*    visible={this.state.visibleUpdateStatus}*/}
        {/*    abstract={abstract}*/}
        {/*    onClose={() => {*/}
        {/*      this.setState({ visibleUpdateStatus: false });*/}
        {/*      // Reloads the window 300ms after the drawer starts closing*/}
        {/*      setTimeout(() => window.location.reload(), 100);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
        {this.state.visibleUpdateStatus && (
          <UpdateStatusDrawer
            visible={this.state.visibleUpdateStatus}
            abstract={abstract}
            onClose={() => {
              this.setState({ visibleUpdateStatus: false });
              this.loadSingleAbstract();
            }}
            onSubmit={() => {
              this.loadSingleAbstract();
            }}
          />
        )}
        {this.state.visibleWithdrawalDrawer && (
          <WithdrawalAbstractDrawer
            visible={this.state.visibleWithdrawalDrawer}
            abstract={abstract}
            onClose={() => this.setState({ visibleWithdrawalDrawer: false })}
          />
        )}
        {this.state.visibleActivityList && (
          <AbstractActivityList
            visible={this.state.visibleActivityList}
            abstractId={abstract._id}
            abstractIdNo={abstract.abstractNo}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        )}
        {/*{this.state.visibleCommentsDrawer && (*/}
        {/*  <CommentsToAbstractDrawer*/}
        {/*    visible={this.state.visibleCommentsDrawer}*/}
        {/*    abstractId={abstract._id}*/}
        {/*    abstract={abstract}*/}
        {/*    onClose={() => this.setState({ visibleCommentsDrawer: false })}*/}
        {/*  />*/}
        {/*)}*/}
        {/*{this.state.visibleCommentsDrawer && (*/}
        {/*  <CommentsToAbstractDrawer*/}
        {/*    visible={this.state.visibleCommentsDrawer}*/}
        {/*    abstractId={abstract._id}*/}
        {/*    abstract={abstract}*/}
        {/*    onClose={() => {*/}
        {/*      this.setState({ visibleCommentsDrawer: false });*/}
        {/*      this.loadSingleAbstract();*/}
        {/*    }}*/}
        {this.state.visibleCommentsDrawer && (
          <CommentsToAbstractDrawer
            visible={this.state.visibleCommentsDrawer}
            abstractId={abstract._id}
            abstract={abstract}
            onClose={() => {
              this.setState({ visibleCommentsDrawer: false });
              this.loadSingleAbstract();
            }}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

// const mapStateToProps = ({ global }) => ({ currentUser: global.currentUser,
//   AbstractReducer: AbstractReducer})
const mapStateToProps = (state) => ({
  currentUser: state.global.currentUser,
  AbstractReducer: state.AbstractReducer
})
export default connect(mapStateToProps)(AbstractView)
